import { reactive, toRefs, onMounted, watch } from "vue";
import Cookie from "@/utils/cache.js";
import { get, post, put } from "../utils/request";
import router from "../router/index";
import { isEmail, isPassword } from "../config/format";
import { messageD } from "../utils/message.js";
import globalStore from "./global";
import { useStoreCommon } from "@/store/common.js";


const data = reactive({
  token: "",
  refreshToken: "",
  user: { endTime: "" },
  userList: [],
  userListTotal: 0,
  userListIndex: 1,
  userDialog: false,
  adminUserList: [],
  searchEmail: "",
  memberStates: [],
  memberState: 2,
  userTerms: [],
  userStates: [],
  userState: 0,
});
watch(
  () => data.memberState,
  async (val) => {
    data.pageIndex = 1;
    methods.getUserList();
  }
);
watch(
  () => data.userState,
  async (val) => {
    data.pageIndex = 1;
    methods.getUserList();
  }
);
const methods = {
  async login(params) {
    const store = useStoreCommon();
    // debugger
    // params.userName= "Administrator"
    // params.password= "Password01!"
    // {
    //   "account": "Administrator",
    //   "password": "Password01!"
    // }
    const res = await post("api/authorize/login", {
      account: params.userName,
      password: params.password,
    }).catch((e) => "账号或密码错误");
    if (res == "账号或密码错误") return;
    const arr = res.data.role.authoritys.map((item) => item.api);
    //一个模块列表(品控、配色、修色模块单独判断)权限都没有并且不是超级管理员
    // let isHasListAuth =
    //   arr.indexOf("list") !== -1;
    // let qualitycontrolAuth =
    //   arr.indexOf(
    //     "calculate.service.qualitycontrol"
    //   ) !== -1;
    // let calculatecolorAuth =
    //   arr.indexOf(
    //     "calculate.service.calculatecolor"
    //   ) !== -1;
    // let carrectbatchAuth =
    //   arr.indexOf(
    //     "calculate.service.carrectbatch"
    //   ) !== -1;
    // let calculatecolorBlendAuth =
    //   arr.indexOf(
    //     "calculate.service.calculatecolor.blend"
    //   ) !== -1;
    // let isAllAuth = res.data.role.isAllAuthority;
    // console.log(
    //   isHasListAuth,
    //   qualitycontrolAuth,
    //   calculatecolorAuth,
    //   carrectbatchAuth,
    //   calculatecolorBlendAuth,
    //   isAllAuth
    // );
    // if (
    //   !isHasListAuth &&
    //   !qualitycontrolAuth &&
    //   !calculatecolorAuth &&
    //   !calculatecolorBlendAuth &&
    //   !carrectbatchAuth &&
    //   !isAllAuth
    // ) {
    //   messageD.error("暂无权限,请联系管理员!");
    //   localStorage.setItem('canLogin', false)
    //   return false;
    // } else {
    //   localStorage.setItem('canLogin', true)
    // }
    localStorage.setItem("canLogin", true);
    localStorage.setItem("isApp", false);
    if (res.succeeded) {
      data.user = res.data;
      Cookie.set("userMa", res.data);
      Cookie.set("accessTokenMa", res.data.accessToken);
      localStorage.setItem("sideBarMenu", JSON.stringify(res.data.menus));
      console.log(res.data.menus);
      store.$reset();
      messageD.success("登陆成功!");
      // let hasColorMatchRole = res.data.menus.some(i => i.path == '/color-match')
      // if (hasColorMatchRole) {
      //   router.push("/color-match")
      // } else {
      //   router.push("/403")
      // }
      router.push("/home");
    }
  },
  loginOut() {
    data.token = "";
    data.user = {};
    data.refreshToken = "";
    Cookie.set("accessTokenMa", "");
    Cookie.set("refreshToken", "");
    // sessionStorage.clear();
    localStorage.removeItem("DripMachineList");
    router.push("/login");
  },
};

export default {
  data,
  ...toRefs(data),
  ...methods,
};
